export const URL_JOBS_PARAM = 'jobs';
export const AVAILABLE_JOB_POSITION = [1, 2, 3, 4, 5, 6, 7, 8, 9];
